import { put, select, takeEvery } from 'redux-saga/effects';
import {
  GlobalAction,
  GlobalActions,
  PreiseStreckeErmittelt,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { ZusatzoptionenNameVWGEnum } from '../models/zusatzoptionenVWG.model';
import { VwgActions } from '../vwgActions';

export function* extremWetterSchutzVorbelegenSaga() {
  yield takeEvery(
    GlobalActions.PREISE_STRECKE_ERMITTELT,
    safeSaga(extremWetterSchutzVorbelegen, App.VWG_V2),
  );
}

export function* extremWetterSchutzVorbelegen(action: GlobalAction<PreiseStreckeErmittelt>) {
  const state: IAppState = yield select();

  if (action.payload.appId != App.VWG_V2 || action.payload.angebotsId != state.angebotsId) {
    return;
  }
  if (state.vertragsoptionen.beibehalten) {
    return;
  }

  const extremWetterSchutzZusatzoption = state.produkt.produktlinien
    .find(produktlinie => produktlinie.selected)
    .zusatzoptionen.find(zusatzoption => zusatzoption.name == ZusatzoptionenNameVWGEnum.ELEMENTAR);
  if (
    extremWetterSchutzZusatzoption.disabled != undefined &&
    !extremWetterSchutzZusatzoption.disabled
  ) {
    return;
  }
  if (!extremWetterSchutzZusatzoption.isSelected) {
    yield put(new VwgActions().zusatzoptionChecked(ZusatzoptionenNameVWGEnum.ELEMENTAR));
  }
}
